import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgVideo(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21.5 15.134C22.1667 15.5189 22.1667 16.4811 21.5 16.866L14 21.1962C13.3333 21.5811 12.5 21.0999 12.5 20.3301V11.6699C12.5 10.9001 13.3333 10.419 14 10.8039L21.5 15.134ZM15 14.268L18 16L15 17.7321V14.268Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 5.75C2.30964 5.75 1.75 6.30964 1.75 7V25C1.75 25.6904 2.30964 26.25 3 26.25H29C29.6904 26.25 30.25 25.6904 30.25 25V7C30.25 6.30964 29.6904 5.75 29 5.75H3ZM4.25 23.75V8.25H27.75V23.75H4.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgVideo);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
